export default __webpack_public_path__ + "38c9167b030b02794c69cd3696f28237.svg";